module.exports = __webpack_public_path__ + "img/madeingermany.2d398de.svg";